import { render, staticRenderFns } from "./PricingTrayPlan.vue?vue&type=template&id=7cef8236&lang=html&"
import script from "./PricingTrayPlan.vue?vue&type=script&lang=js&"
export * from "./PricingTrayPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports